import React from 'react'
import Link from 'gatsby-link'
import SideNav from '../../layouts/side-nav.js'

import './style/index.css'

const components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business']

// let title
// switch (this.state.current.title) {
//   case 'press': title = 'Press'; break
//   case 'why': title = 'Why Lease'; break
//   case 'history': title = 'History'; break
//   case 'case-study': title = 'Case Study'; break
//   case 'questions': title = '10 Questions'; break
//   case 'lease-loan': title = 'Lease vs Loan'; break
//   case 'good-business': title = 'Good Business'; break
//   default: title = 'Why Lease'
// }

export default () => (
  <div>
    <div className='why-hero'>
      <div className='why-hero-img' />
    </div>
    <div className='why-title'>
      Why Lease
    </div>
    <div className='why-content'>
      <SideNav components={components} base='why' current='why' />
      <p>
        We've all heard that old adage, it takes money to make money. It's an unavoidable fact of business life. We all need equipment to do our jobs and deliver our products or services - and that equipment costs money.
      </p>
      <p>
        As businesses prepare to compete and grow in a new millennium, many are searching for proven new ways to address their equipment financing challenge. The old ways won't meet today's and tomorrow's needs. The choice for many businesses is clear: equipment leasing.
      </p>
      <p>
        Throughout the first decade of the twenty first century, the total business equipment financing (loans and leases) owned and securitized by the finance companies has fluctuated between $300 and 350 million as reported by the ELFA, from a Federal Reserve report. This is a significant increase over prior decades and bodes well for increased industrial reliance in the future.
      </p>
      <p>
        Find out more ways leasing can help your business by clicking on the links to the left. If you still have more questions, feel free to <Link className='why-contact-us' to='/contact'>contact us</Link>.
      </p>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/why/index.js